import { transformWaitMusic } from '../../waitMusic/utils/transformWaitMusic';
/**
 * Returns the transformed flow response.
 *
 * @param response The raw response from the flow endpoint.
 */
export function transformFlowResponse(response) {
    transformFlowActions(response.data.actions);
    return response;
}
/**
 * Returns the transformed flows response.
 *
 * @param response The raw response from the flows endpoint.
 */
export function transformFlowsResponse(response) {
    response.data.flows.forEach(({ actions }) => transformFlowActions(actions));
    return response;
}
/**
 * Performs various transformations on the actions of a flow.
 *
 * @param actions The actions
 */
function transformFlowActions(actions) {
    actions.forEach((action) => {
        // Remove deprecated fields that are no longer necessary to read from.
        delete action.text;
        delete action.icon;
        delete action.isAction;
        delete action.overlay;
        delete action.badges;
        if (typeof action.wait_music_v2 !== 'undefined') {
            action.wait_music = action.wait_music_v2;
            transformWaitMusic(action.wait_music);
            delete action.wait_music_v2;
        }
    });
}
/**
 * Returns the transformed flow schedule response.
 *
 * @param response The response from the endpoint.
 */
export function transformFlowScheduleResponse(response) {
    return Object.assign({}, response.data);
}
/**
 * Returns the transformed flow schedule preview response.
 *
 * @param response The response from the endpoint.
 */
export function transformFlowSchedulePreviewResponse(response) {
    return Object.assign({}, response.data);
}
/**
 * Returns the transformed flow schedule country response.
 *
 * @param response The response from the endpoint.
 */
export function transformFlowScheduleCountryResponse(response) {
    return Object.assign({}, response.data);
}
